import {FilterFieldTypeEnum} from "../../model/filter-types";
import {FilterStateType} from "../../model/types";


type CheckboxParamPayload = {
    key: string;
    value: boolean;
}
type CheckboxListParamPayload = {
    key: string;
    value: string;
}
type RangeParamPayload = {
    key: string;
    value: number[];
}

// Типы payload'ов по каждому типу фильтра
export type FilterPayloadMap = {
    [FilterFieldTypeEnum.checkbox]: CheckboxParamPayload;
    [FilterFieldTypeEnum.checkbox_list]: CheckboxListParamPayload;
    [FilterFieldTypeEnum.range]: RangeParamPayload;
};

type FilterBuilderFn<K extends FilterFieldTypeEnum> = (
    state: FilterStateType,
    payload: FilterPayloadMap[K]
) => FilterStateType;


/**
 * Карта функций `filterBuilders`, обрабатывающих изменение состояния фильтров
 * по каждому типу фильтра (checkbox, checkbox_list, range).
 *
 * Каждая функция:
 * - принимает текущее состояние фильтров (`FilterStateType`)
 * - получает payload (ключ + новое значение)
 * - возвращает новое состояние фильтров
 *
 * Типизация обеспечена через `FilterPayloadMap` и `FilterBuilderFn`
 */
export const filterBuilders: {
    [K in FilterFieldTypeEnum]: FilterBuilderFn<K>
} = {
    [FilterFieldTypeEnum.checkbox]: (state, payload) => {
        if (payload.value) {
            return {...state, [payload.key]: [Number(payload.value)]};
        }
        // Clean up state when the checkbox is unchecked
        const {[payload.key]: _, ...cleanedState} = state;  // Destructuring to remove the key
        return cleanedState;
    },
    [FilterFieldTypeEnum.checkbox_list]: (state, payload) => {
        // Ensure the key exists in state or initialize it as an empty array
        const prev = state?.[payload.key] as string[] || [];
        const value = payload.value as string

        // Add or remove the value from the list
        const updatedList = prev.includes(value)
            ? prev.filter(i => i !== value)  // Remove if it already exists
            : [...prev, value];              // Add if not already in the list

        if (!updatedList.length) {
            const {[payload.key]: _, ...cleanedState} = state;
            return cleanedState
        }

        return {...state, [payload.key]: updatedList};
    },
    [FilterFieldTypeEnum.range]: (state, payload) => {
        //если массив пустой, очищаем состояние фильтра по ключу
        if (!Array.isArray(payload.value) || !payload.value.length) {
            const {[payload.key]: _, ...cleanedState} = state;
            return cleanedState
        }
        return {
            ...state,
            [payload.key]: [`>${payload.value[0]}`, `<${payload.value[1]}`]

        }
    }
};